function resetData(data = {}) {
    if (data?.constructor === Object) {
        return Object.entries(data).reduce((result, [key, value]) => {
            result[key] = resetData(value);
            return result;
        }, {});
    } else if (data?.constructor === Array) {
        return data.map(resetData);
    }
    return "";
}

document.addEventListener("bcpR4q:submitQuoteSuccess", function () {
    const r4qFormData = JSON.parse(localStorage.getItem("r4qFormData") || "{}");
    localStorage.setItem("r4qFormData", JSON.stringify(resetData(r4qFormData)));
});